const screenshotHistory = {
    namespaced: true,
    state: {
        screenshots: {}
    },
    mutations: {
        putScreenshots(state, data) {
            state.screenshots[data.deviceId] = data.screenshots;
            state.screenshots = { ...state.screenshots };
        },
        putScreenshot(state, data) {
            if (Array.isArray(state.screenshots[data.deviceId])) {
                for (let sc of state.screenshots[data.deviceId]) {
                    if (sc.imagePath == data.imagePath) {
                        sc.base64 = data.screenshot.base64;
                        state.screenshots = { ...state.screenshots };
                        break;
                    }
                }
            }
        }
    },
    actions: {
        getScreenshotHistory(context, deviceId) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/device/screenshothistory/getScreenshotHistory', { params: { 'deviceid': deviceId } })
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('putScreenshots', {
                                'deviceId': deviceId,
                                'screenshots': response.data
                            });
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        getScreenshot(context, qp) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/device/screenshothistory/getScreenshot', { params: { 'path': qp.imagePath } })
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('putScreenshot', {
                                'deviceId': qp.deviceId,
                                'imagePath': qp.imagePath,
                                'screenshot': response.data
                            });
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        }
    }
}

export default screenshotHistory;